import React from 'react';
import { styled } from '@compiled/react';
import { FormattedMessage } from 'react-intl-next';

import { token } from '@atlaskit/tokens';
import Badge from '@atlaskit/badge';

import { LoadingState } from '../homeViewsQueryHelpers';

import { TaskView, SortTypes, SortOptions } from './tasksDefinitions';
import { useFiltersReducer } from './Filters/useFiltersReducer';
import { useGetTasksQuery } from './useGetTasksQuery';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'flex',
	flexDirection: 'row',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'> span:last-child': {
		marginLeft: token('space.100', '8px'),
	},
});

export const TaskNavigationItem = ({ isSelected = false }) => {
	const [filterState] = useFiltersReducer();
	const { tasks, loadingState, error } = useGetTasksQuery({
		filters: filterState.filters,
		taskView: TaskView.Assigned,
		sortType: SortTypes.Date,
		sortOption: SortOptions.Ascending,
	});

	let count = '-';

	if (!error && loadingState === LoadingState.done) {
		if (tasks.length > 99) {
			count = '99+';
		} else {
			count = String(tasks.length);
		}
	}

	return (
		<Container>
			<FormattedMessage
				id="home.navigation.tasks-home"
				defaultMessage="Tasks"
				description="Link to a list of tasks assigned to the user or created by them"
			/>
			<Badge appearance={isSelected ? 'primary' : 'default'}>{count}</Badge>
		</Container>
	);
};
